const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-909,-418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.984,437.968C920.808,437.968 922.496,437.512 924.048,436.6C925.552,435.736 926.736,434.552 927.6,433.048C928.512,431.496 928.968,429.808 928.968,427.984C928.968,426.16 928.512,424.472 927.6,422.92C926.736,421.416 925.552,420.232 924.048,419.368C922.496,418.456 920.808,418 918.984,418C917.176,418 915.496,418.456 913.944,419.368C912.44,420.248 911.248,421.44 910.368,422.944C909.456,424.496 909,426.176 909,427.984C909,429.792 909.456,431.472 910.368,433.024C911.232,434.528 912.416,435.72 913.92,436.6C915.472,437.512 917.16,437.968 918.984,437.968ZM919.968,424.984L918,424.984L918,422.968L919.968,422.968L919.968,424.984ZM919.968,433L918,433L918,427L919.968,427L919.968,433Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.04e0b800aab0608d55e07ca84ec264a2.svg";
export { ForwardRef as ReactComponent };